import React from "react";
import { Instagram, Facebook } from "lucide-react";

const TikTokIcon = ({ size = 18, className = "" }) => (
  <svg
    viewBox="0 0 24 24"
    fill="currentColor"
    width={size}
    height={size}
    className={className}
    aria-hidden
  >
    <path d="M19.59 6.69a4.83 4.83 0 0 1-3.77-4.25V2h-3.45v13.67a2.89 2.89 0 0 1-5.2 1.74 2.89 2.89 0 0 1 2.31-4.64 2.93 2.93 0 0 1 .88.13V9.4a6.84 6.84 0 0 0-1-.05A6.33 6.33 0 0 0 5.8 20.1a6.34 6.34 0 0 0 10.86-4.43V8.85a8.16 8.16 0 0 0 4.77 1.52V6.93a4.85 4.85 0 0 1-1.84-.24z" />
  </svg>
);

const SOCIALS = [
  {
    name: "Instagram",
    href: "https://www.instagram.com/societybeautyrevolution",
    Icon: Instagram,
  },
  {
    name: "TikTok",
    href: "https://www.tiktok.com/@societybeautyrevolution",
    Icon: TikTokIcon,
  },
  {
    name: "Facebook",
    href: "https://www.facebook.com/societybeautyrevolution",
    Icon: Facebook,
  },
];

export default function SocialIcons({ size = "md" }) {
  const dims = size === "lg"
    ? { box: "w-12 h-12", icon: 18 }
    : { box: "w-11 h-11", icon: 16 };

  return (
    <div className="flex items-center gap-3">
      {SOCIALS.map(({ name, href, Icon }) => (
        <a
          key={name}
          href={href}
          target="_blank"
          rel="noopener noreferrer"
          aria-label={name}
          data-testid={`social-${name.toLowerCase()}`}
          className={`group relative ${dims.box} rounded-full flex items-center justify-center transition-transform duration-300 hover:scale-110 hover:-translate-y-0.5`}
        >
          {/* Gold glow halo (always subtle, brighter on hover) */}
          <span
            className="absolute inset-0 rounded-full blur-md opacity-25 group-hover:opacity-90 transition-opacity duration-300"
            style={{
              background:
                "radial-gradient(closest-side, #f3a85c, transparent 70%)",
            }}
          />
          {/* Outer ring (fades on hover) */}
          <span className="absolute inset-0 rounded-full border border-white/15 transition-opacity duration-300 group-hover:opacity-0" />
          {/* Gold gradient fill on hover */}
          <span
            className="absolute inset-0 rounded-full opacity-0 group-hover:opacity-100 transition-opacity duration-300"
            style={{
              background:
                "linear-gradient(135deg, #f3a85c 0%, #e07c33 55%, #c25b1f 100%)",
              boxShadow:
                "0 6px 24px -4px rgba(243,168,92,0.55), inset 0 0 12px rgba(255,220,170,0.45)",
            }}
          />
          {/* Icon */}
          <Icon
            size={dims.icon}
            className="relative z-10 text-white/85 group-hover:text-[#0a0a0a] transition-colors duration-300"
          />
        </a>
      ))}
    </div>
  );
}
